import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretDownLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.625 6.53003L9 12.155L3.375 6.53003", stroke: "#525A68", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretDownLine);
const Memo = memo(ForwardRef);
export default Memo;
